"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.dialogVisible ? _c("el-dialog", {
    staticClass: "add_dialog",
    attrs: {
      width: "600px",
      title: _vm.dialogTitle,
      visible: _vm.dialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      rules: _vm.rules,
      model: _vm.form,
      "label-width": "120px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "用途",
      prop: "remark"
    }
  }, [_c("el-input", {
    attrs: {
      type: "text",
      placeholder: "请输入用途"
    },
    model: {
      value: _vm.form.purpose,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "purpose", $$v);
      },
      expression: "form.purpose"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "金额",
      prop: "remark"
    }
  }, [_c("el-input", {
    attrs: {
      type: "number",
      placeholder: "请输入金额"
    },
    model: {
      value: _vm.form.money,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "money", $$v);
      },
      expression: "form.money"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "操作人",
      prop: "remark"
    }
  }, [_c("el-input", {
    attrs: {
      type: "text",
      placeholder: "请输入操作人"
    },
    model: {
      value: _vm.form.operator,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "operator", $$v);
      },
      expression: "form.operator"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "支出日期",
      prop: "time"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "datetime",
      placeholder: "选择日期",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: _vm.form.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "time", $$v);
      },
      expression: "form.time"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("保 存")])], 1)], 1) : _vm._e()], 1);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;
render._withStripped = true;